import { render, staticRenderFns } from "./mandatoryAssign.vue?vue&type=template&id=332ab7b5&"
import script from "./mandatoryAssign.vue?vue&type=script&lang=ts&"
export * from "./mandatoryAssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports